export const MAILS_BASE_ROUTES = '/mails';
export const MAIL_ATTACHMENT_ATTACHED = 'attachment';
export const MAIL_ATTACHMENT_INLINE = 'inline';
export const MAIL_MODULE_KEY = 'mails';
export const MAILS_MODULE_KEY = 'mails';
